import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Account from './pages/Account';
import About from './pages/About';
import Attributions from './pages/Attributions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import ContactUs from './pages/ContactUs';
import Login from './pages/Login';
import ResetPasswordForm from './pages/ResetPasswordForm';
import ConfirmEmail from './pages/ConfirmEmail';
import Stores from './pages/Stores';
import Groceries from './pages/Groceries';
import ViewGrocery from './pages/ViewGrocery';
import Prices from './pages/Prices';
import ViewGroceryPrices from './pages/ViewGroceryPrices';
import ShoppingLists from './pages/ShoppingLists';
import ViewShoppingList from './pages/ViewShoppingList';
import GoingShopping from './pages/GoingShopping';
import ShoppingActivity from './pages/ShoppingActivity';
import ViewStore from './pages/ViewStore';
import GettingStarted from './pages/GettingStarted';
import Admin from './pages/Admin';
import AdminUsers from './pages/AdminUsers';
import AdminSiteSettings from './pages/AdminSiteSettings';
import AdminEmailHub from './pages/AdminEmailHub';
import AdminMessages from './pages/AdminMessages';
import AdminTutorials from './pages/AdminTutorials';
import AdminPayments from './pages/AdminPayments';
import AdminPromotions from './pages/AdminPromotions';
import AdminAuditTrails from './pages/AdminAuditTrails';
import AdminErrorTracking from './pages/AdminErrorTracking';
import AdminAnalytics from './pages/AdminAnalytics';
import PrivateRoute from './components/PrivateRoute';
import ScrollToTop from './components/ScrollToTop';

const AppRoutes: React.FC = () => {
  return (
    <>
      <ScrollToTop />{/* Forces new pages to render with the page scrolled to the top */}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/account" element={<PrivateRoute><Account /></PrivateRoute>} />
        <Route path="/about" element={<About />} />
        <Route path="/attributions" element={<Attributions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/reset-password" element={<ResetPasswordForm />} />
        <Route path="/confirm-email" element={<ConfirmEmail />} />
        <Route path="/getting-started" element={<PrivateRoute><GettingStarted /></PrivateRoute>} />
        <Route path="/stores" element={<PrivateRoute><Stores /></PrivateRoute>} />
        <Route path="/groceries" element={<PrivateRoute><Groceries /></PrivateRoute>} />
        <Route path="/groceries/:id" element={<PrivateRoute><ViewGrocery /></PrivateRoute>} />
        <Route path="/prices" element={<PrivateRoute><Prices /></PrivateRoute>} />
        <Route path="/prices/grocery/:id" element={<PrivateRoute><ViewGroceryPrices /></PrivateRoute>} />
        <Route path="/shopping-lists" element={<PrivateRoute><ShoppingLists /></PrivateRoute>} />
        <Route path="/shopping-lists/:id" element={<PrivateRoute><ViewShoppingList /></PrivateRoute>} />
        <Route path="/going-shopping" element={<PrivateRoute><GoingShopping /></PrivateRoute>} />
        <Route path="/shopping-activity" element={<PrivateRoute><ShoppingActivity /></PrivateRoute>} />
        <Route path="/stores/:id" element={<PrivateRoute><ViewStore /></PrivateRoute>} />
        {/* Admin routes */}
        <Route path="/admin" element={<PrivateRoute><Admin /></PrivateRoute>} />
        <Route path="/admin/users" element={<PrivateRoute><AdminUsers /></PrivateRoute>} />
        <Route path="/admin/settings" element={<PrivateRoute><AdminSiteSettings /></PrivateRoute>} />
        <Route path="/admin/email-hub" element={<PrivateRoute><AdminEmailHub /></PrivateRoute>} />
        <Route path="/admin/messages" element={<PrivateRoute><AdminMessages /></PrivateRoute>} />
        <Route path="/admin/tutorials" element={<PrivateRoute><AdminTutorials /></PrivateRoute>} />
        <Route path="/admin/payments" element={<PrivateRoute><AdminPayments /></PrivateRoute>} />
        <Route path="/admin/promotions" element={<PrivateRoute><AdminPromotions /></PrivateRoute>} />
        <Route path="/admin/audit-trails" element={<PrivateRoute><AdminAuditTrails /></PrivateRoute>} />
        <Route path="/admin/error-tracking" element={<PrivateRoute><AdminErrorTracking /></PrivateRoute>} />
        <Route path="/admin/analytics" element={<PrivateRoute><AdminAnalytics /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
